/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-10-02 09:09:22
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Field } from 'redux-form';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import {
  isRequired,
  nonSpecialCharacters,
  isValidUrl,
  isCDNUrl,
  isImageUrl
} from 'src/helpers/form-validation-helper';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  item: Object
};

type ComposedProps = Props & WithI18nProps;

class RenderImageSelect extends Component<ComposedProps> {
  isRequiredValue = isRequired(
    this.props.i18n.translate('AdminHTML.SwatchSettings.Validate.invalid_RequiredValue')
  );
  nonSpecialCharactersValue = nonSpecialCharacters(
    this.props.i18n.translate('AdminHTML.SwatchSettings.Validate.invalid_nonSpecialCharactersValue')
  );
  isValidUrlValue = isValidUrl(
    this.props.i18n.translate('AdminHTML.SwatchSettings.Validate.invalid_ValidUrlValue')
  );
  isCDNUrlValue = isCDNUrl(
    this.props.i18n.translate('AdminHTML.SwatchSettings.Validate.invalid_CDNUrlValue')
  );
  isImageUrlValue = isImageUrl(
    this.props.i18n.translate('AdminHTML.SwatchSettings.Validate.invalid_ImageUrlValue')
  );

  render() {
    const { i18n, item } = this.props;
    return (
      <div>
        <Field
          name={`${item}.imageUrl`}
          component={RenderTextField}
          placeholder={i18n.translate(
            'AdminHTML.SwatchSettings.SwatchSettings.swatchValue_Image_Placeholder'
          )}
          validate={[
            this.isRequiredValue,
            this.nonSpecialCharactersValue,
            this.isValidUrlValue,
            this.isCDNUrlValue,
            this.isImageUrlValue
          ]}
        />
      </div>
    );
  }
}

export default withI18n()(RenderImageSelect);
